import {Component, OnInit, ElementRef, ViewChild, Output, EventEmitter, Input} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ExportToCsv } from 'export-to-csv';

import { CDSNode, Rule } from '../services/capd.model';
import { RulesService } from '../services/rules.service';
import { OrgService } from '../services/org.service';
import {AlertService} from "../services/alert.service";

declare var $: any;

@Component({
  templateUrl: './group.component.html'
})

/**
 * Parent component for all group content.
 */
export class GroupContentComponent implements OnInit {
  root: string;
  org: CDSNode;
  data: any = [];
  packRules: Rule[] = [];
  selectedRule: Rule;
  ruleEdits: Rule[] = [];
  groupList: CDSNode[];
  hasGroups: boolean = false;
  groupToCopy: CDSNode[] = [];

  @ViewChild('cboxConfirmRef') cboxConfirmRef: ElementRef;

  // Group delete rules modal variables
  @Output() ruleDeleted = new EventEmitter();
  isDisabled = true;
  infoRule: Rule;

  watermarkText = '<span>Loading...<br /><img src="./app/css/img/linear-loader.gif" alt=""/></span>';

  private sub: any;

  constructor(
    private _router: Router,
    private _route: ActivatedRoute,
    private _el: ElementRef,
    private _rules: RulesService,
    private _org: OrgService,
    private alertService: AlertService) {}

  /**
   * Gets the current group.
   *
   * @async
   * @func ngOnInit
   */
  ngOnInit() {
    this.sub = this._route.params.subscribe(params => {
      this.root = params.id;
      this.watermarkText = '<span>Loading...<br /><img src="./app/css/img/linear-loader.gif" alt=""/></span>';
      var orgRoot = this.root.split('+')[0]
      var groupExt = this.root.split('+')[1]
      this.doUpdate(orgRoot, groupExt);

      this._org.getGroup(orgRoot, groupExt).then((org: CDSNode) => {
        if (org !== undefined) {
          this.org = org;
        } else {
          this._org.getGroupsById(orgRoot).then((groups: CDSNode[]) => {
            this.groupList = groups.filter(node => node.extensionId == groupExt);
            this.org = this.groupList[0];
          });
        }
      }).then(() => {
        this._org.getGroups(this.org).then((groups: CDSNode[]) => {
          this.groupList = groups.filter(node => node.extensionId != this.org.extensionId);
          // @ts-ignore
          if (this.groupList == null || this.groupList.length == 0)
            this.hasGroups = false;
          else
            this.hasGroups = true;
        })
      })
          .catch(err => this.watermarkText = '<span>There are no rules to display for this group.</span>');
    });

  }

  /**
   * Toggles checkbox that disables the delete button by default.
   *
   * @func toggleDisabled
   */
  toggleDisabled() {
    this.isDisabled = !this.isDisabled;
  }

  /**
   * Deletes the selected rules.
   *
   * @async
   * @func onDelete
   */
  onDelete() {
    try {
    this.ruleEdits.forEach(rule => {
      rule.group_id = this.org.rootId + "/" + this.org.extensionId;
    });

    let ruleEditsCopy = JSON.parse(JSON.stringify(this.ruleEdits));
      this._org.deleteRulesForGroup(ruleEditsCopy, this.org.extensionId, this.org.rootId)
          .then(res => {
            this.ruleDeleted.emit(null);
            this.doUpdate(this.org.rootId, this.org.extensionId);
            this.ruleEdits = [];
          });
      this.closeDeleteModal();
    } catch(e) {
      this.alertService.showAlert("An error occurred while attempting to update group rules.");
      this.closeDeleteModal();
      var orgRoot = this.root.split('+')[0]
      var groupExt = this.root.split('+')[1]
      this.doUpdate(orgRoot, groupExt);
    }
  }

  openDropdown() {
    // if rule drop down is already visible, close it instead
    if($('#stateOptions').is(':visible'))
      this.closeDropdown()
    else
    $('#stateOptions').show();
  }

  closeDropdown() {
    $('#stateOptions').hide();
  }

  /**
   * Called whenever the list of rules is updated or changed.
   * Gets all group rules and then creates a CSV data file for them.
   *
   * @func doUpdate
   */
  doUpdate(orgId, extensionId) {
    this._rules.getGroupRulesFullDetails(orgId, extensionId).then((res: Rule[]) => {
      // filter out any rules that do not contain a trigger name
      // this often happens when they have been removed from the root level
      res = res.filter(r => r.triggerName)
      this.packRules = res.sort((a, b) => {
        const test1 = a.contentPackage_id.localeCompare(b.contentPackage_id);
        if (test1 !== 0) { return test1; }
        else { return a.triggerName.localeCompare(b.triggerName); }
      });

      this.watermarkText = '<span>There are no rules to display for this group.</span>';
      this.packRules.forEach(rule => {
        if (!rule.state) {
          rule.state = 'Silent';
        }

      });
      this.createCsv();
    });
  }

  /**
   * Checks if the list of rules to make edits to is empty.
   *
   * @func toAddIsEmpty
   * @returns true if the list is empty, and false otherwise.
   */
  toAddIsEmpty() {
    return !this.ruleEdits || this.ruleEdits.length < 1;
  }

  openDeleteModal() {
    this.isDisabled = true;
    $(this._el.nativeElement).find('#modal-delete-rule').show();
  }

  closeDeleteModal() {
      if (this.cboxConfirmRef) {
          this.cboxConfirmRef.nativeElement.checked = false;
      }
      $(this._el.nativeElement).find('#modal-delete-rule').hide();
  }

  /**
   * Checks or unchecks a rule to edit.
   *
   * @func onSelect
   * @param {Rule} rule - the rule to check/uncheck.
   */
  onSelect(rule: Rule) {
    const index = this.ruleEdits.indexOf(rule);
    if (index < 0) {
      this.ruleEdits.push(rule);
    }
    else {
      this.ruleEdits.splice(index, 1);
    }
    // if the final rule is unselected, automatically close rule dropdown
    if(this.ruleEdits.length == 0)
      this.closeDropdown();
  }

  /**
   * Uses the checkbox on the header to select/deselect all rules automatically.
   *
   * @func onHeaderSelect
   */
  onHeaderSelect() {
    if (this.ruleEdits.length >= this.packRules.length) {
      this.ruleEdits.splice(0, this.ruleEdits.length);
      $('input[type=checkbox]').prop('checked', false);
    } else {
      this.packRules.forEach(rule => this.addAll(rule));
    }
  }

  /**
   * Adds all rules not currently selected, one by one.
   *
   * @func addAll
   * @param {Rule} rule - the current rule being added.
   */
  addAll(rule: Rule) {
    const index = this.ruleEdits.indexOf(rule);
    if (index < 0) {
      this.ruleEdits.push(rule);
    }
  }

  /**
   * Displays the info for the selected rule.
   *
   * @async
   * @func onInfo
   * @param {Rule} rule - the rule to display info for.
   */
  onInfo(rule: Rule) {
      this.infoRule = rule;
      $('#modal-rule-details').show();
  }

  closeInfoDetails() {
    $(this._el.nativeElement).find('#modal-rule-details').hide();
  }

  /**
   * Changes the state of the selected rules.
   *
   * @async
   * @func onSubmit
   * @param {string} newState - the state to set the rules to.
   */
  onSubmit(newState: string) {
    try {
      // ensure we do not change the associated rootId
      let orgRootId_to_update;
      this.ruleEdits.forEach(rule => {
        rule.state = newState;
        orgRootId_to_update = rule.org_id;
        rule.group_id = this.org.rootId + "/" + this.org.extensionId;
      });
      this._org.updateRulesForGroup(this.ruleEdits, this.org.extensionId, orgRootId_to_update).then(res => {
        this.ruleEdits = [];
        this.createCsv();
      });
      this.closeDropdown();
      this.ruleEdits = [];
      $('input[type=checkbox]').prop('checked', false);
    } catch(e) {
      this.alertService.showAlert("An error occurred while attempting to update group rules.");
      var orgRoot = this.root.split('+')[0]
      var groupExt = this.root.split('+')[1]
      this.doUpdate(orgRoot, groupExt);
    }
  }

  /**
   * Creates a CSV file that shows the list of rules added to a customer in a portable table.
   *
   * @func createCsv
   */
  createCsv() {
    this.data = [];
    this.packRules.forEach(rule => {
        const ruleData = {
          ruleTriggerCode: rule.triggerCode,
          ruleId: rule.rule_id,
          ruleName: rule.triggerName,
          rulePackage: rule.contentPackage_id,
          ruleState: rule.state
        };
        this.data.push(ruleData);
      })
  }

  /**
   * Saves a copy of the csv to your local drive.
   *
   * @func exportCsv
   */
  exportCsv() {
    let nameForFile = '';
    if(this.org && this.org.description) {
      nameForFile = this.org.description.replaceAll(" ", "")
    }
    const options = {
      filename: nameForFile + 'Export-'+Date.now(),
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalSeparator: '.',
      showLabels: true,
      showTitle: true,
      title: 'Company Package Export CSV',
      useTextFile: false,
      useBom: true,
      useKeysAsHeaders: true
    };

    const csvExporter = new ExportToCsv(options);
    if(!(this.data === undefined) && this.data !== null && Array.isArray(this.data) && this.data.length > 0) {
      csvExporter.generateCsv(this.data);
    } else {
      this.alertService.showAlert("Invalid Export. No data provided.");
    }

  }

  showRuleCopyModal() {
    this.ruleEdits = [];
    $(this._el.nativeElement).find('#modal-group-list').show();
  }

  hideRuleCopyModal() {
    $(this._el.nativeElement).find('#modal-group-list').hide();
    this.clearSelections();
  }

  /**
   * Adds or removes a selected option to the list of groups to copy rules to.
   *
   * @func updateChecked
   * @param {any} option - the option to add or remove.
   */
  updateChecked(option) {
    // Check to see if the option is in the array
    const index = this.groupToCopy.indexOf(option);
    // If it's not, add it to the end
    if (index < 0) {
      this.groupToCopy.push(option);
    }
    // Otherwise, remove it
    else {
      this.groupToCopy.splice(index, 1);
    }
  }

  /**
   * Call org service with the list of rules assigned to this group, along with a list of groups to copy this content to.
   * On completion, close the copy modal.
   *
   * @func submitRuleCopy
   */
  submitRuleCopy() {
    this._org.copyRulesToGroup(this.packRules, this.org.extensionId, this.org.rootId, this.groupToCopy).then(() => this.hideRuleCopyModal());
  }

  /**
   * Clear the list of groups to copy content to, close rule copy modal.
   *
   * @func cancelRuleCopy
   */
  cancelRuleCopy() {
    $('input[type=checkbox]').prop('checked', false);
    this.clearSelections();
    this.hideRuleCopyModal();
  }

  /**
   * Clear the list of groups to copy content to.
   *
   * @func clearSelections
   */
  clearSelections() {
    this.groupToCopy = new Array(0);
  }
}
